import { render, staticRenderFns } from "./CVideoMenu.vue?vue&type=template&id=2d05998a&scoped=true&"
import script from "./CVideoMenu.vue?vue&type=script&lang=js&"
export * from "./CVideoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05998a",
  null
  
)

export default component.exports